import { gql } from '@apollo/client'

export default gql`
  mutation duplicateGroup($id: ID!) {
    duplicateGroup(id: $id) {
      id
    }
  }
`
